/**
 * Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { JaoAggregation } from './jaoAggregation';
import { JaoAllocationTimeSeries } from './jaoAllocationTimeSeries';


export interface JaoCompleteDto { 
    blocks?: Array<JaoAllocationTimeSeries> | null;
    aggregations?: Array<JaoAggregation> | null;
}

